import Vue from 'vue'
import VeeValidate, { Validator } from 'vee-validate'
import ptBR from 'vee-validate/dist/locale/pt_BR'
import CpfValidator from './validations/cpf.validator'
import CnpjValidator from './validations/cnpj.validator'
import MoneyValidator from './validations/money.validator'
import ZeroValidator from './validations/zero.validator'
import DecimalBrValidator from './validations/decimal-br.validator'

Vue.use(VeeValidate)

Validator.localize('pt_BR', ptBR)

Validator.extend('zero', ZeroValidator)
Validator.extend('money', MoneyValidator)
Validator.extend('cpf', CpfValidator)
Validator.extend('cnpj', CnpjValidator)
Validator.extend('decimal-br', DecimalBrValidator)
